import { setToken, getToken, setUserInfo, getUserInfo } from '@/utils/auth'
import { getSysConfig } from '@/api/home'
import { loginbyuid, getuserDetail } from '@/api/user.js'
import { getcartTreelist } from '@/api/cart.js'
import { checkArea } from '@/utils/index'
import { QQMAP_KEY } from '@/utils/config'
import Vue from 'vue'
import router from '../../router'
const userInfo = getUserInfo() || {}
const state = {
    isLogin: !!getToken(),
    user: userInfo, // 用户信息
    location: null, // 定位信息
    cartNum: 0, // 购物车数量
    config: null, // 配置信息
    currencyarea: 0, // 0 中国澳门  1 中国大陆
    unit: 'MOP'
}

const mutations = {
    CHANGE_SETTING: (state, data) => {
        const keys = Object.keys(data)
        keys.forEach(key => {
            if (state.hasOwnProperty(key)) {
                state[key] = data[key]
            }
        })
    }
}

const actions = {
    // 获取系统配置信息
    getSysConfig({ commit }) {
        return new Promise((resolve, reject) => {
            getSysConfig().then(({ data }) => {
                commit('CHANGE_SETTING', {
                    config: data
                })
                resolve(data)
            })
        })
    },
    // 微信H5登录
    login({ commit }, uid) {
        localStorage.clear()
        loginbyuid({
            uid: uid
        }).then(async res => {
            setToken(`${res.data.token_type} ${res.data.access_token}`)
            await actions.updateUserInfo({ commit })
            router.push('/')
        })
    },
    // 获取用户信息
    updateUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            getuserDetail().then(({ data }) => {
                if (data.id) {
                    commit('CHANGE_SETTING', {
                        isLogin: true
                    })
                    actions.updateInfo({ commit }, data)
                    resolve(data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 获取当前定位
    getLocation({ commit }) {
        return new Promise((resolve) => {
            let location = {
                lat: 0,
                lng: 0
            }
            const currentLocation = sessionStorage.getItem('location')
            if (currentLocation) {
                commit('CHANGE_SETTING', {
                    location: JSON.parse(currentLocation),
                    currencyarea: sessionStorage.getItem('currencyarea') || 0,
                    unit: sessionStorage.getItem('unit')
                })
                resolve(JSON.parse(currentLocation))
                return
            }
            Vue.prototype.$jsonp('https://apis.map.qq.com/ws/location/v1/ip', {
                key: QQMAP_KEY,
                output: "jsonp"
            }).then(res => {
                const data = res.result
                // 定位获取失败
                if (!data) {
                    commit('CHANGE_SETTING', {
                        location: location,
                        currencyarea: 0,
                        unit: 'MOP'
                    })
                    sessionStorage.setItem('location', JSON.stringify(location))
                    sessionStorage.setItem('currencyarea', 0)
                    sessionStorage.setItem('unit', 'MOP')
                    resolve(location)
                    return
                }
                location = {
                    lat: data.location.lat,
                    lng: data.location.lng
                }
                commit('CHANGE_SETTING', {
                    location: location,
                    currencyarea: checkArea(data.ad_info.province),
                    unit: checkArea(data.ad_info.province) === 1 ? 'RMB' : 'MOP'
                })
                sessionStorage.setItem('location', JSON.stringify(location))
                sessionStorage.setItem('currencyarea', checkArea(data.ad_info.province))
                sessionStorage.setItem('unit', checkArea(data.ad_info.province) === 1 ? 'RMB' : 'MOP')
                resolve(location)
            }).catch(() => {
                sessionStorage.setItem('location', JSON.stringify(location))
                sessionStorage.setItem('currencyarea', 0)
                sessionStorage.setItem('unit', 'MOP')
                resolve(location)
            })
        })
    },
    // 退出登录
    logout({ commit }) {
        localStorage.clear()
        commit('CHANGE_SETTING', {
            user: {},
            isLogin: false
        })
    },
    // 更新用户信息
    updateInfo({ commit }, obj) {
        const res = Object.assign(userInfo, obj)
        commit('CHANGE_SETTING', res)
        setUserInfo(res)
    },
    // 更新购物车数量
    updateCart({ commit }) {
        getcartTreelist().then(({ data }) => {
            commit('CHANGE_SETTING', {
                cartNum: data.length
            })
        })
    }
}

export default {
    state,
    mutations,
    actions
}